import { render, staticRenderFns } from "./chart_biax.vue?vue&type=template&id=24d6a562"
import script from "./chart_biax.vue?vue&type=script&lang=js"
export * from "./chart_biax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports